<template>
	<div v-if="user">
		<!-- SIDEBAR -->
		<div class="menu" :style="{ width: sidebar ? '' : '75px' }">
			<button-collapse-sidebar :open="sidebar" @change="sidebar = !sidebar" />
			<div v-if="isSuperAdmin">
				<el-tooltip placement="right" :open-delay="sidebar ? 1000 : 100">
					<div slot="content">{{ $t("type") }}</div>
					<div
						class="item"
						@click="() => goTo('/wizards/1')"
						:class="{
							'item-selected': this.selected_nodes[0]
								? this.selected_nodes[0].type == 'type'
								: this.$route.fullPath.includes('1')
						}"
					>
						<md-icon
							:style="{
								color: selected.includes('type') ? 'white' : '#cfd8dc',
								marginLeft: !sidebar ? 'auto' : '',
								marginRight: !sidebar ? 'auto' : ''
							}"
							>loyalty</md-icon
						>
						<span v-if="sidebar">{{ $t("types") }}</span>
					</div>
				</el-tooltip>
				<el-tooltip placement="right" :open-delay="sidebar ? 1000 : 100">
					<div slot="content">{{ $t("folders") }}</div>
					<div
						class="item"
						@click="() => goTo('/wizards/2')"
						:class="{
							'item-selected': this.selected_nodes[0]
								? this.selected_nodes[0].type == 'folder'
								: this.$route.fullPath.includes('1')
						}"
					>
						<md-icon
							:style="{
								color: selected.includes('folders') ? 'white' : '#cfd8dc',
								marginLeft: !sidebar ? 'auto' : '',
								marginRight: !sidebar ? 'auto' : ''
							}"
							>new_label</md-icon
						>
						<span v-if="sidebar">{{ $t("folders") }}</span>
					</div>
				</el-tooltip>
				<el-tooltip placement="right" :open-delay="sidebar ? 1000 : 100">
					<div slot="content">{{ $t("new") }}</div>

					<el-popover placement="right" width="160" trigger="hover">
						<div class="item" @click="() => goTo('/wizards/new/type')">
							<md-icon
								:style="{
									color: '#000000',
									marginLeft: !sidebar ? 'auto' : '',
									marginRight: !sidebar ? 'auto' : ''
								}"
								>new_label</md-icon
							>
							<span v-if="sidebar" style="color: #000000">{{ $t("type") }}</span>
						</div>
						<div class="item" @click="() => goTo('/wizards/new/folder')">
							<md-icon
								:style="{
									color: '#000000',
									marginLeft: !sidebar ? 'auto' : '',
									marginRight: !sidebar ? 'auto' : ''
								}"
								>new_label</md-icon
							>
							<span v-if="sidebar" style="color: #000000">{{ $t("folder") }}</span>
						</div>

						<div slot="reference" class="item" :class="{ 'item-selected': false }">
							<md-icon
								:style="{
									color: selected.includes('new') ? 'white' : '#cfd8dc',
									marginLeft: !sidebar ? 'auto' : '',
									marginRight: !sidebar ? 'auto' : ''
								}"
								>new_label</md-icon
							>
							<span v-if="sidebar">{{ $t("new") }}</span>
						</div>
					</el-popover>
				</el-tooltip>

				<el-tooltip placement="right" :open-delay="sidebar ? 1000 : 100">
					<div slot="content">{{ $t("all") }}</div>
					<div
						class="item"
						@click="() => goTo('/wizards/')"
						:class="{
							'item-selected': !this.$route.fullPath.includes('1') && !this.$route.fullPath.includes('2')
						}"
					>
						<md-icon
							:style="{
								color: selected.includes('all') ? 'white' : '#cfd8dc',
								marginLeft: !sidebar ? 'auto' : '',
								marginRight: !sidebar ? 'auto' : ''
							}"
							>apps</md-icon
						>
						<span v-if="sidebar">{{ $t("all") }}</span>
					</div>
				</el-tooltip>
			</div>
		</div>

		<!-- MAIN -->
		<div class="main" :style="{ width: widthscreen, marginLeft: !sidebar ? '75px' : '150px' }">
			<div style="padding: 10px; margin-top: 15px">
				<app-breadcrumb :history="breadcrumb" @mutate="doMutate" />
				<router-view />
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { goto } from "@/utils/utils"
import ButtonCollapseSidebar from "@/modules/_common/button/button-collapse-sidebar.vue"
import AppBreadcrumb from "@/modules/_common/app-breadcrumb.vue"

export default {
	name: "wizard-layout",
	components: {
		"button-collapse-sidebar": ButtonCollapseSidebar,
		AppBreadcrumb
	},

	data() {
		return {
			sidebar: true || window.innerWidth < 900,
			widthscreen: window.innerWidth - 150,
			heightscreen: window.innerHeight,
			mobile: window.innerWidth < 900
		}
	},
	computed: {
		...mapGetters({
			breadcrumb: "data/breadcrumb",
			user: "user/user",
			isSuperAdmin: "user/isSuperAdmin",
			selected_nodes: "wizard/nodes"
		}),
		selected: function () {
			return this.$route.name
		}
	},
	methods: {
		goto,
		...mapActions({
			doMutate: "data/doMutate"
		}),
		goTo: function (where) {
			this.$goTo(where)
		}
	}
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/collapse-button";
.main {
	margin-top: -25px;
}

.menu {
	font-family: "Montserrat", sans-serif;
	z-index: 2;
	position: absolute;
	left: 0;
	bottom: 0;
	top: 63px;
	width: 150px;
	background-color: #455a64;
	transition: width 0.5s;
}

.item {
	padding: 17px 10px;
	cursor: pointer;
	color: #cfd8dc;
	width: 100%;
	&:hover {
		border-left: 3px solid #6ff9ff;
	}
	display: flex;
	.md-icon {
		margin-left: 5px;
		margin-right: 5px;
	}
	span {
		margin-top: auto;
		margin-bottom: auto;
	}
}

.item-selected {
	border-left: 3px solid #6ff9ff;
	color: white;
	background-color: rgba(127, 127, 127, 0.1);
}

.selected {
	color: #6ff9ff;
}
</style>
